export interface Success<T> {
  type: "SUCCESS";
  data: T;
}

export interface VoidSuccess {
  type: "SUCCESS";
}

export interface Created<T> {
  type: "CREATED";
  data: T;
  location: string | null;
}

export interface NotFound {
  type: "NOT_FOUND";
  reason?: any;
}

export interface ValidationFailed {
  type: "VALIDATION_FAILED";
  reason: string;
}

export interface DatabaseError {
  type: "DATABASE_ERROR";
  reason: string;
}

export interface ExternalError {
  type: "EXTERNAL_ERROR";
  reason: string;
}

export interface UnexpectedHttpStatus {
  type: "UNEXPECTED_HTTP_ERROR";
  response: Response;
}

export interface UnexpectedError {
  type: "UNEXPECTED_ERROR";
  reason: any;
}

export const unexpectedHttpStatus = (
  response: Response
): UnexpectedHttpStatus => ({
  type: "UNEXPECTED_HTTP_ERROR",
  response
});

export const unexpectedError = (reason: any): UnexpectedError => ({
  type: "UNEXPECTED_ERROR",
  reason
});
